<div class="plan text-center" [ngClass]="class">
  <img [src]="image">
  <h3 class="text-dark space-1">{{title}}</h3>
  <div class="dash y-center"></div>
  <p class="y-center desc">
    {{description}}
  </p>
</div>
